/* eslint-disable jsx-a11y/no-distracting-elements */
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import animaionImageHOme from "../../assets/2f53o.gif";
import animaionImageHOmes from "../../assets/home_offers.gif";
import ProductCard from "../ProductCard";
import SkeletonLoader from "../SkeletonLoader";
import Spinner from "../Spinner/index";
import "./index.css";

const Home = () => {
  const navigate = useNavigate();
  const [categoryArray, setCategoryArray] = useState([]);
  const [productsArray, setProductsArray] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFetchingNext, setIsFetchingNext] = useState(false);

  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (ref?.current) {
      if (["STOPPED", "COMPLETED"].includes(ref?.current?.state?.status)) {
        ref?.current?.start();
      }
    }
  }, [location, ref]);

  const sliderImages = JSON.parse(process.env.REACT_APP_SLIDER || "[]");

  const cacheKey = "all_products";
  const categoryCacheKey = "all_categories"; // ✅ NEW ADD

  const getCategoryFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get("category") || params.get("cat");
  };

  const fetchCategories = async () => {
    const cachedCategory = sessionStorage.getItem(categoryCacheKey);
    if (cachedCategory) {
      const parsed = JSON.parse(cachedCategory);
      const age = Date.now() - parsed.timestamp;

      // 👉 if cache is fresh (5 min), return directly
      if (age < 5 * 60 * 1000) {
        setCategoryArray(parsed.data);
        return parsed.data;
      }
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/category/get`
      );
      const arr = (res.data?.statusCode === 1 ? res.data?.data : []) || [];
      setCategoryArray(arr);
      sessionStorage.setItem(
        categoryCacheKey,
        JSON.stringify({ data: arr, timestamp: Date.now() })
      );
      return arr;
    } catch (error) {
      console.error("Error loading categories", error);
      setCategoryArray([]);
      return [];
    }
  };

  const fetchProductsByCategory = async (categoryId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/get?category=${categoryId}`
      );
      if (res.data?.statusCode === 1) {
        return res.data.data || [];
      }
    } catch (err) {
      console.error("Error fetching products for category:", categoryId, err);
    }
    return [];
  };

  const sortProductsByCategory = (data, categoryId) => {
    if (!categoryId || !Array.isArray(data)) return data;
    const index = data.findIndex((item) => item._id === categoryId);
    if (index === -1) return data;
    const reordered = [...data];
    const [selected] = reordered.splice(index, 1);
    return [selected, ...reordered];
  };

  const fetchNextCategory = async (categories, index, finalCategoryId) => {
    if (index >= categories.length) return;
    setIsFetchingNext(true);
    const cat = categories[index];
    const products = await fetchProductsByCategory(cat._id);

    setProductsArray((prev) => {
      //  prevent duplicates when going back
      const exists = prev.find((p) => p._id === cat._id);
      if (exists) return prev;

      const updated = [...prev, { _id: cat._id, name: cat.name, products }];

      sessionStorage.setItem(
        cacheKey,
        JSON.stringify({
          products: updated,
          timestamp: Date.now(),
        })
      );

      return sortProductsByCategory(updated, finalCategoryId);
    });
    setIsFetchingNext(false);
    fetchNextCategory(categories, index + 1, finalCategoryId);
  };

  //  Main fix: always fetch categories, restore cache if available
  useEffect(() => {
    const finalCategoryId = getCategoryFromURL();
    const cachedData = sessionStorage.getItem(cacheKey);

    const init = async () => {
      const categories = await fetchCategories();

      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        const age = Date.now() - parsed.timestamp;

        if (age < 5 * 60 * 1000) {
          const sorted = sortProductsByCategory(
            parsed.products,
            finalCategoryId
          );

          setProductsArray(sorted);

          setIsLoader(false);
          return;
        }
      }

      // no valid cache → start fresh
      if (categories?.length) {
        fetchNextCategory(categories, 0, finalCategoryId);
        setIsLoader(false);
      } else {
        setProductsArray([]);
        setIsLoader(false);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const settingSlick = {
    dots: false,
    infinite: sliderImages.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="category_block">
      <Container>
        <Row>
          {/* <div className="ps-0 pe-0">
            <img
              src={animaionImageHOme}
              className="w-100"
              alt={window.location.hostname}
            />
          </div> */}
          {/* <div className="ps-0 pe-0">
            <img
              src={animaionImageHOmes}
              className="w-100 object-cover "
              alt={window.location.hostname}
              style={{
                objectFit: "cover",
                height: "55px",
                backgroundColor: "var(--them-color)",
              }}
            />
          </div> */}
        </Row>

        <Row>
          {sliderImages.length > 0 && (
            <Col
              md={12}
              lg={12}
              xs={12}
              className="position-relative sliders_main ps-0 pe-0"
            >
              <Slider {...settingSlick}>
                {sliderImages?.map((image, index) => (
                  <div key={index} className="d-flex">
                    <img
                      src={image}
                      alt={`Knee ${index + 1}`}
                      className="w-full rounded-lg"
                      style={{ width: "100%", overflow: "hidden" }}
                    />
                  </div>
                ))}
              </Slider>
            </Col>
          )}
        </Row>

        {isLoader && productsArray.length === 0 ? (
          <Spinner />
        ) : (
          <>
            <div
              className="menu"
              style={{
                backgroundColor: process.env.REACT_APP_THEAM_COLOR,
                margin: "0 -12px",
              }}
            >
              <marquee
                width="100%"
                direction="left"
                height="30px"
                fontWeight="700"
                style={{ color: "white" }}
              >
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
              </marquee>
            </div>

            <div className="p-1 font-serif 'container">
              {categoryArray.length > 1 && (
                <h3 className="text-2xl font-semibold mb-3 my-2">
                  SHOP BY CATEGORY
                </h3>
              )}
              <Row className="g-1">
                {categoryArray.length > 1 &&
                  categoryArray.map((item, index) => (
                    <Col
                      key={index}
                      xs={6}
                      onClick={() => navigate(`/category/${item?._id}`)}
                      className="cursor-pointer"
                    >
                      <div className="bg-white shadow rounded-lg p-2 d-flex gap-2 align-items-center justify-content-center">
                        <div>
                          <img
                            src={item?.image}
                            className="object-cover rounded"
                            width="45"
                            height="45"
                            alt={item?.name}
                          />
                        </div>
                        <div className="font-medium text-sm text-truncate">
                          {item?.name}
                        </div>
                      </div>
                    </Col>
                  ))}
              </Row>
            </div>

            {isLoader ? (
              <Row xs={2} md={2} className="g-0 mt-2">
                {[1, 2, 3, 4].map((i) => (
                  <Col key={i}>
                    <SkeletonLoader />
                  </Col>
                ))}
              </Row>
            ) : (
              productsArray?.map((item, index) => {
                return (
                  item?.products?.length > 0 && (
                    <div key={item._id || index}>
                      <h4 className="card-title text-center fw-bold my-3">
                        {item.name}
                      </h4>
                      <Row xs={2} md={2} className="g-0 mt-2">
                        {item.products.map((product, idx) => (
                          <ProductCard
                            key={product._id || idx}
                            item={product}
                            index={idx}
                          />
                        ))}
                      </Row>
                      <Button
                        className="btn my-3 d-flex justify-content-center align-items-center ripple animated"
                        style={{
                          fontWeight: 600,
                          fontSize: "18px",
                          margin: "auto",
                          borderWidth: "2px",
                          padding: "10px 20px",
                          borderColor: "var(--them-color)",
                          color: "var(--them-color)",
                          background: "#ffff",
                        }}
                        onClick={(e) => {
                          e?.target?.classList?.add("bounceIn");
                          navigate(`/category/${item._id}`);
                          setTimeout(() => {
                            e?.target?.classList?.remove("bounceIn");
                          }, 1000);
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  )
                );
              })
            )}

            {isFetchingNext && (
              <Row xs={2} md={2} className="g-0 mt-2">
                {[1, 2, 3, 4].map((i) => (
                  <Col key={i}>
                    <SkeletonLoader />
                  </Col>
                ))}
              </Row>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default Home;
